/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const MidLongTerm = ({
    goalSummary,
    stepsToAchieve,
    startDate,
    endDate,
}: Partial<{
    goalSummary: string;
    stepsToAchieve: string;
    startDate: string;
    endDate: string;
}>) => (
    <>
        <Row>
            <ValueCell label="Goal Summary" value={goalSummary} />
        </Row>
        <Row>
            <ValueCell label="Planned Steps to Achieve this Goal" value={stepsToAchieve} />
        </Row>
        <Row>
            <ValueCell single label="Date From" value={startDate} />
            <ValueCell single label="Date To" value={endDate} />
        </Row>
    </>
);

export default MidLongTerm;
